import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { WhiteBoardFileIcon, WhiteboardImageIcon } from '@sketchnote/icons';
import { Button, Panel as Panel2, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { ToolButton, useTldrawApp } from 'sn-wb-tldraw';

export const ImageUpload = React.memo(function ColorMenu(): JSX.Element {
  const app = useTldrawApp();

  const handleUploadMedia = React.useCallback(() => {
    app.selectTool('select');
    app.openAsset();
  }, [app]);

  const isSmallScreen = window.innerHeight < 800;

  return (
    <Menu placement="right" direction="ltr" isLazy offset={[0, 15]}>
      <div>
        <MenuButton
          className="h-36 w-36 smallScreen:w-23 smallScreen:h-23 flex justify-center items-center cursor-pointer"
          style={{
            border: '0.79px solid #E2E4E9',
            borderRadius: '3.17241px',
          }}
        >
          <WhiteboardImageIcon wrapperClass={'transform smallScreen:scale-60'} />
        </MenuButton>
        <p
          style={{
            fontSize: `${isSmallScreen ? '8px' : '12.48px'}`,
            textAlign: 'center',
            lineHeight: `${isSmallScreen ? '16px' : '24.96px'}`,
          }}
        >
          Image
        </p>
      </div>

      <MenuList>
        <div className="flex flex-col p-16 rounded-lg bg-white shadow-sm text-gray-999 min-w-292">
          <Tabs selected={0} size="small" className="border-b">
            <Panel2 title="Upload">
              <div className="my-16">
                <MenuItem>
                  <Button onClick={handleUploadMedia} className="justify-center w-full">
                    Choose an Image
                  </Button>
                </MenuItem>
              </div>
            </Panel2>
          </Tabs>
        </div>
      </MenuList>
    </Menu>
  );
});
